import "./namespace.js";
import "#/legacy/namespaces.js";

// Multi-value filter apps (`sp-finder-filter`) expose `setFilterValues` only
// post-mount; operational readiness is
// `window.Sparkle.CustomElements.whenMountReady`, identical under both builds.
DoctorFinder.Helpers.FilterAppReadiness = {
  // Applies a restore payload when the element is operational, or stashes it
  // on the host for `flushPendingRestore` to replay once it becomes so.
  restore(element, values, metadata) {
    if (typeof element.setFilterValues === "function") {
      if (metadata === undefined) {
        element.setFilterValues(values);
      } else {
        element.setFilterValues(values, metadata);
      }
    } else {
      element.__pendingFilterRestore = values;
      element.__pendingFilterRestoreMetadata = metadata;
    }
  },

  // Replays a stashed restore payload once the element is operational (see
  // `whenOperational`); pre-operational the call is a no-op that keeps the
  // stash for a later flush.
  flushPendingRestore(element) {
    if (element.__pendingFilterRestore == null || typeof element.setFilterValues !== "function") {
      return;
    }

    const values = element.__pendingFilterRestore;
    const metadata = element.__pendingFilterRestoreMetadata;
    delete element.__pendingFilterRestore;
    delete element.__pendingFilterRestoreMetadata;
    if (metadata === undefined) {
      element.setFilterValues(values);
    } else {
      element.setFilterValues(values, metadata);
    }
  },

  // Resolves with the element once its exposed methods are callable; rejects
  // when it settled as a terminal load failure. When the mount-ready helper is
  // unavailable (a page without the custom-elements entry) it resolves
  // immediately.
  whenOperational(element) {
    const whenMountReady = window.Sparkle?.CustomElements?.whenMountReady;

    if (!whenMountReady) {
      return Promise.resolve(element);
    }

    return whenMountReady(element);
  },
};
